export default [
  {
    key: 'checkbox',
    label: '',
    sortable: true,
    thClass: 'align-middle',
    tdClass: 'align-middle',
    show: true,
    type: 'checkbox',
  },
  {
    key: 'id',
    label: 'ID',
    sortable: true,
    thClass: 'align-middle',
    tdClass: 'align-middle',
    show: false,
  },
  {
    key: 'inventory',
    label: 'Inventory',
    sortable: true,
    thClass: 'align-middle',
    tdClass: 'align-middle',
    show: true,
  },
  {
    key: 'line_item',
    label: 'Line Item',
    sortable: true,
    thClass: 'align-middle',
    tdClass: 'align-middle',
    show: true,
  },
  {
    key: 'first_party_impressions',
    label: '1P Impressions',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'third_party_impressions',
    label: '3P Impressions',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'first_party_total',
    label: '1P Total',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'third_party_total',
    label: '3P Total',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'delta',
    label: 'Delta',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    thClass: 'align-middle text-center',
    tdClass: 'align-middle text-center',
    show: true,
  },
  {
    key: 'action',
    label: '',
    sortable: false,
    show: true,
    type: 'action_list',
    tdClass: 'actions',
    thStyle: { width: '160px' },
    class: 'text-center align-middle text-capitalize',
    thClass: 'align-middle text-center',
    actions: [
      {
        icon: 'check',
        title: 'Approve',
        event: 'approve',
        show: (item: any) => item.status !== 'approved',
      },
      {
        icon: 'redo',
        title: 'Reopen',
        event: 'reopen',
        show: (item: any) => item.status === 'approved',
      },
    ],
  },
]
